import React, { useContext, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Dialog from 'libraries/Dialog';
import { errorMessage } from 'helper/constants';
import { observer } from 'mobx-react-lite';
import { appCtx } from '../../appStore';
import ModalText from './modalText';

const styles = {
    button: {
        minHeight: 36,
        minWidth: 182,
        paddingLeft: 25,
        paddingRight: 25,
        fontWeight: 'bold'
    },
    progress: {
        color: 'white',
        '& svg': {
            margin: 0
        }
    }
};

const ResetAuditionDialog = observer(({
    open, callback, classes,
    requestFunc,
    user, handleClose
}) => {
    const [disabled, setDisabled] = useState(false);
    const { flashMessage } = useContext(appCtx);

    const resetAudition = async () => {
        setDisabled(true);
        try {
            const data = await requestFunc();
            if (data.success) {
                setDisabled(false);
                handleClose();
                flashMessage('Extended successfully', 'done');
                if (callback && data.candidates) callback(data.candidates);
                if (callback && data.data && data.data.candidates) callback(data.data.candidates);
            } else {
                handleClose();
            }
        } catch (e) {
            console.log(e);
            flashMessage(e?.response?.data?.msg || errorMessage, 'error');
            setDisabled(false);
        }
    };

    let { fullName } = user;
    if (!fullName) {
        fullName = user ? `${user.first_name} ${user.last_name ? `${user.last_name} ` : ''}` : '';
    }
    return (
        <Dialog
            open={open}
            maxWidth="sm"
            handleClose={handleClose}
            titleComponent="Extend Deadline for Candidate"
            actionComponent={(
                <>
                    <Button
                        color="primary"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        className={classes.button}
                        color="primary"
                        variant="contained"
                        onClick={resetAudition}
                        disabled={disabled}
                    >
                        {
                            disabled ? (
                                <CircularProgress
                                    size={22}
                                    className={classes.progress}
                                />
                            ) : (
                                <>
                                    <span>Extend deadline</span>
                                </>
                            )
                        }
                    </Button>
                </>
            )}
        >
            <ModalText />
        </Dialog>
    );
});

export default withStyles(styles)(ResetAuditionDialog);
